export enum PermissionsListAction {
  SET_PERMISSIONS = 'SET_PERMISSIONS',
}
